const addTrailingSlash = (url: string): string => (url.endsWith('/') ? url : `${url}/`);

export default addTrailingSlash;
